export default {
  networkText: {
    timeOut: 'Your active session has timeout. Request you re-login.',
    unableToProcess: 'Sorry! We are unable to process your request. Please re-try after sometime.',
    noInternet:"There seems to be a network issue at your end. Please switch to another network to proceed."
  },
};
